import React, { useState } from 'react';
import axios from 'axios';
import './extra-css/login.css';
//import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';

function Login() {
  const [errorMessage, setErrorMessage] = useState('');

  const handleLogin = async (username, password) => {
    const csrfToken = Cookies.get('csrftoken');
    try {
      const response = await axios.post('https://iscreenfix.com/api/login/signin/', {
        username,
        password,
      }, {
        headers: {
          'X-CSRFToken': csrfToken,
        },
        withCredentials: true
      });
      localStorage.setItem('username', response.data.username);
      localStorage.setItem('accessToken', response.data.token);
      window.location.reload();
    } catch (error) {
      console.error('Login error', error.response ? error.response.data : 'Unknown Error');
      setErrorMessage('Failed to login. Please try again.');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const username = e.target.username.value;
    const password = e.target.password.value;
    handleLogin(username, password);
  };

  const handleGuestLogin = () => {
    // Use the guest account credentials here
    const guestUsername = 'Guest'; // Replace with your guest account's username
    const guestPassword = '0HHEhV8gZLlVJfHN6Mq4GiTPEgqfnry'; // Replace with your guest account's password

    handleLogin(guestUsername, guestPassword);
  };

  return (
    <div className="page-container">
      <img src="/assets/images/logo.png" alt="Logo" className="login-logo" />
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="form-title">Login to iScreenFix</div>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        <input
          name="username"
          type="text"
          placeholder="Username"
        />
        <input
          name="password"
          type="password"
          placeholder="Password"
        />
        <button type="submit">Login</button>
        <button type="button" onClick={handleGuestLogin} className="guest-btn">Continue as Guest</button>
        <a href="/" className="back-to-home-btn" onClick={(e) => {
          e.preventDefault();
          window.location.href = '/';
        }}>Back to Home</a>
      </form>
    </div>
  );
}

export default Login;
